<div class="relative">
  <button
    class="text-green-600 hover:scale-110 transition-transform hover:text-green-800 cursor-pointer"
    type="button"
    (click)="isOpen = true"
    appAgentAction
    agent="export-selection-open"
    businessObject="swPartNumber"
    [businessId]="$safeNavigationMigration(swPartNumber?.id)"
    action="open"
  >
    <app-download-icon></app-download-icon>
  </button>
  <div
    role="tooltip"
    class="absolute z-10 right-4 top-6 inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-md w-72"
    [class.invisible]="!isOpen"
    [class.opacity-0]="!isOpen"
  >
    <div class="p-3 space-y-2">
      <div class="flex justify-between">
        <h3 class="font-bold text-gray-800">Export</h3>
        <app-close-icon
          class="cursor-pointer hover:scale-110 transition-transform"
          (click)="isOpen = false"
          appAgentAction
          agent="export-selection-close"
          businessObject="swPartNumber"
          [businessId]="$safeNavigationMigration(swPartNumber?.id)"
          action="close"
        ></app-close-icon>
      </div>

      <button
        (click)="swPartNumberDownloadClicked.emit(swPartNumber); isOpen = false"
        *appIfPolicySatisfied="policy.canUpdateTranslations"
        type="button"
        class="text-purple-400 disabled:text-gray-400 hover:text-purple-600 cursor-pointer hover:scale-105 hover:bg-orange-100 p-0.5 rounded-md"
        appAgentAction
        agent="export-selection-download-terminal-data"
        businessObject="swPartNumber"
        [businessId]="$safeNavigationMigration(swPartNumber?.id)"
        action="download"
      >
        <div class="flex items-start gap-x-4">
          <app-download-icon class="font-medium"></app-download-icon>
          <p class="text-xs text-gray-500 text-start">
            Download the main language terminal field data (DTC and Error Message) as a ZIP file
          </p>
        </div>
      </button>

      <button
        (click)="swPartNumberDocDownloadClicked.emit(swPartNumber); isOpen = false"
        *appIfPolicySatisfied="policy.canUpdateTranslations"
        type="button"
        class="text-orange-500 disabled:text-gray-400 hover:text-orange-700 cursor-pointer hover:scale-105 hover:bg-orange-100 p-0.5 rounded-md"
        appAgentAction
        agent="export-selection-download-documentation-data"
        businessObject="swPartNumber"
        [businessId]="$safeNavigationMigration(swPartNumber?.id)"
        action="download"
      >
        <div class="flex items-start justify-between gap-x-4">
          <div class="relative font-medium">
            <app-download-icon></app-download-icon>
            <span class="text-[8px] absolute top-4 -end-1">DOC</span>
          </div>
          <p class="text-xs text-gray-500 text-start">
            Download the main language documentation field data (DTC) for the technical redaction as an XML file
          </p>
        </div>
      </button>

      <div class="border-b border-gray-300"></div>

      <button
        (click)="resetOnTerminalExportedClicked.emit(swPartNumber); isOpen = false"
        *appIfPolicySatisfied="policy.canResetTrReviewFlags"
        type="button"
        class="text-gray-500 disabled:text-gray-400 hover:text-gray-700 cursor-pointer hover:scale-105 hover:bg-orange-100 p-0.5 rounded-md"
        appAgentAction
        agent="export-selection-reset-terminal-flags"
        businessObject="swPartNumber"
        [businessId]="$safeNavigationMigration(swPartNumber?.id)"
        action="reset"
      >
        <div class="flex items-start justify-between gap-x-4">
          <app-wrench-icon></app-wrench-icon>
          <p class="text-xs text-gray-500 text-start">Reset "Exported for review by TR" flag (OnTerminal)</p>
        </div>
      </button>

      <button
        (click)="resetDocumentationExportedClicked.emit(swPartNumber); isOpen = false"
        *appIfPolicySatisfied="policy.canResetTrReviewFlags"
        type="button"
        class="text-gray-500 disabled:text-gray-400 hover:text-gray-700 cursor-pointer hover:scale-105 hover:bg-orange-100 p-0.5 rounded-md"
        appAgentAction
        agent="export-selection-reset-documentation-flags"
        businessObject="swPartNumber"
        [businessId]="$safeNavigationMigration(swPartNumber?.id)"
        action="reset"
      >
        <div class="flex items-start justify-between gap-x-4">
          <div class="relative font-medium">
            <app-wrench-icon></app-wrench-icon>
            <span class="text-[8px] absolute top-4 -end-1">DOC</span>
          </div>
          <p class="text-xs text-gray-500 text-start">Reset "Exported for review by TR" flag (Documentation)</p>
        </div>
      </button>

      <div class="border-b border-gray-300"></div>

      <button
        *appIfPolicySatisfied="policy.canPublishSyncEvents"
        (click)="publishEventsClicked.emit(swPartNumber); isOpen = false"
        type="button"
        class="text-blue-500 disabled:text-gray-400 hover:text-blue-700 cursor-pointer hover:scale-105 hover:bg-orange-100 p-0.5 rounded-md"
        appAgentAction
        agent="export-select-popover-publish-service-bus-events"
        businessObject="swPartNumber"
        [businessId]="$safeNavigationMigration(swPartNumber?.id)"
        action="export"
      >
        <div class="flex items-start gap-x-4">
          <app-cloud-arrow-up-icon></app-cloud-arrow-up-icon>
          <p class="text-xs text-gray-500 text-start">Publish DTC and Error Message synchronisation events for AMAiQ</p>
        </div>
      </button>
    </div>
  </div>
</div>
